<template>
  <div class="approval">
    <!--  盖章审批(新增、编辑) -->
    <!-- apply approval (create, update) and sign approval (create, update) -->
    <div class="content">
      <el-form
        size="mini"
        ref="formApproval"
        @submit.native.prevent
        :model="approvalModel"
        label-width="100px"
      >
        <el-form-item
          label="审批名称"
          prop="approvalName"
          :rules="rules.approvalName"
        >
          <el-input
            style="width: 300px"
            v-model="approvalModel.approvalName"
            placeholder="请输入审批名称"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="使用范围" prop="dingTalkUserIds">
          <ul class="custom-inline">
            <li>
              <el-button @click="initMemberForm">选择</el-button>
            </li>
            <li style="margin-top: 20px">
              <el-tag
                v-for="tag in approvalModel.dingTalkUserIds"
                :key="tag.name"
                type="danger"
                style="margin: 0 10px"
              >
                {{ tag.name }}
              </el-tag>
            </li>
          </ul>
        </el-form-item> -->

        <el-form-item label="审批类型" prop="approvalType" :rules="rules.approvalType">
          <el-radio-group v-model="approvalModel.approvalType">
            <el-radio :label="1">顺序审批（按先后顺序审批）</el-radio>
            <el-radio :label="2">会审 （无顺序，全员通过则通过）</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <p slot="label">审批复用&nbsp;&nbsp;
            <el-tooltip content="开启后，若审批人已参与同一合同的发起审批，则在成员发起用印申请时无需再次审批。" placement="top-end">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </p>
          <el-radio-group v-model="approvalModel.useFileAuditFlag">
            <el-radio :label="1">开</el-radio>
            <el-radio :label="2">关</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="审批流程">
          <div style="display: inline; position: relative">
            <div class="flow-sty">
              <div v-for="user of flows" :key="user.emplId" class="box-sty">
                <p class="men-item">
                  <img
                    src="/images/web/p-default.png"
                    width="50px"
                    height="50px"
                    alt=""
                  />
                  <span>{{ user.name }}</span>
                  <span
                    class="item-close close_icon"
                    @click="delUser(user)"
                  ></span>
                </p>
                <i
                  class="icon icon-audit-jiantou32"
                  style="width: 30px"
                  v-show="approvalModel.approvalType === 1"
                ></i>
              </div>
            </div>
            <el-popover placement="right">
              <div style="padding: 20px">
                <p style="margin-bottom: 20px">
                  <el-button
                    size="mini"
                    style="width: 125px"
                    @click="addManager"
                    >添加直属部门主管</el-button
                  >
                </p>
                <p>
                  <el-button
                    size="mini"
                    style="width: 125px"
                    @click="handleClickFlowPlus"
                    >选择成员</el-button
                  >
                </p>
              </div>
              <!-- <plus slot="reference" @handleClickFlowPlus="handleClickFlowPlus"></plus> -->
              <plus slot="reference"></plus>
            </el-popover>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <!-- footer (cancel and submit button) -->
    <div class="footer" style="text-align: right">
      <el-button @click="approvalCancel" size="mini">取消</el-button>
      <el-button
        @click="approvalOk"
        size="mini"
        type="danger"
        style="margin-right: 50px"
        >确定</el-button
      >
    </div>
  </div>
</template>

<script>
import Flow from "../../../components/flow";
import Plus from "../../../components/flow/Plus";
import ElGo from "../../../components/go/Go";

import { callbackLog } from "@/assets/js/utils/publicMethods";
import { dingtalkApi } from "../../../assets/js/http-serve/dingtalkApi";
// ⚠️ dingtalk-jsapi 只能在客户端（浏览器）中使用
let dd = null;
if (process.client) {
  dd = require('dingtalk-jsapi');
}
export default {
  name: "approval",
  props: ['currentFlowId', 'currentFlow', 'addFlowPupVisi'],
  components: { Flow, Plus, ElGo },
  data () {
    return {
      // 【1466】
      // 查看使用范围
      viewRangeVisi: false,
      // 选择
      // 【1466】 end
      // approval model include apply and sign
      approvalModel: {
        approvalName: "",
        aprrovalID: "",
        approvalRange: "", // only apply approval
        selectUsers: [],
        approvalType: 1,
        useFileAuditFlag:1,
        approvalFlow: "",
        copyToName: "",
        dingTalkUserIds: null
      },
      rules: {
        approvalName: [
          { required: true, message: "请输入审批名称", trigger: "blur" },
          { min: 1, max: 20, message: "长度在 1 到 20 个字符", trigger: "blur" }
        ],
        approvalType:[{ required: true, message: "请选择审批类型", trigger: "blur" }],
        dingTalkUserIds: [
          { required: true, message: "请选择使用范围", trigger: ["blur", 'change'] },
        ],
      },
      selectedApproval: [],

      // approval flow
      addOrUpdateApprovalor: true, // true add , false update
      flows: []
    };
  },
  computed: {
    addOrUpdateApprovalorTitle () {
      if (this.addOrUpdateApprovalor) {
        return "添加审批人";
      } else {
        return "编辑审批人";
      }
    },
    flowType () {
      return 1;
    },
    flowId () {
      return this.currentFlowId;
    }
  },
  methods: {
    // 初始化编辑弹窗及回显
    intUpdate(){
      this.$nextTick(() => {
        const { flowId, flowName, flowType, status, nodes,useFileAuditFlag } = this.currentFlow;
        this.approvalModel.approvalName = flowName ? flowName : ''
        this.approvalModel.approvalType = parseInt(flowType)
        this.approvalModel.useFileAuditFlag = parseInt(useFileAuditFlag)
        // this.approvalModel.approvalType = parseInt(flowType) == 1 ? 1 : 1
        // this.approvalModel.useFileAuditFlag = parseInt(useFileAuditFlag) == 1 ? 1 : 1
        if (nodes) {
          const _nodes = [...nodes];
          let _flows = [];
          _nodes.map(item => {
            item.userApproveUsers.forEach(user => {
              const _user = { name: user.name, emplId: user.userId };
              _flows.push(_user);
            });
          });
          this.flows = _flows;
        }
      });
    },
    // 【1466】 start
    /** 选择 */
    initMemberForm () {
      // 鉴权 + 选人
      const corpId = sessionStorage.getItem("corpId"), _this = this;
      let users = [];
      if (_this.flowId && _this.approvalModel.dingTalkUserIds) users = _this.approvalModel.dingTalkUserIds.map(user => {
        return user.emplId
      })
      dd.chooseStaffForPC({
        max: 50,
        users,
        corpId,
        multiple: true,
        success: res => {
          _this.$set(_this.approvalModel, 'dingTalkUserIds', [...res])
        },
      }).catch((err) => { console.log('catch_err', err); });
    },
    // 【1466】 end
    /** 获取流程适用范围 */
    initApprovalInfo () {
      const { dingTalkCorpId: corpId,
        dingTalkUserId } = JSON.parse(sessionStorage.getItem("dingloginInfo"))
      let params = {
        corpId,
        dingTalkUserId,
        flowId: this.flowId
      }, _this = this;
      dingtalkApi.workflowInfo(params)
        .then(res => {
          if (res.code === "0") {
            // convert form data
            if (res.data) {
              // let data = res.data;
              // const dingUser = data.dingTalkUsers.map(user => {
              //   return { name: user.dingTalkUserName, emplId: user.dingTalkUserId }
              // })
              // _this.$set(_this.approvalModel, 'dingTalkUserIds', dingUser)
            }
          } else {
            _this.$message.error(res.description);
          }
        })
        .catch(error => {
          console.log('catch_err', error);
          this.$message.error(error.description);
        });
    },
    // 删除某个审批人
    delUser (user) {
      this.flows.forEach((item, i) => {
        const idType = item.emplId === user.emplId;
        if (idType) {
          this.flows.splice(i, 1);
        }
      });
    },
    approvalCancel () {
      this.$emit('update:addFlowPupVisi', false);
      return false; //取消后续逻辑，不要弹窗
      this.$confirm("是否保存审批?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.approvalOk();
        })
        .catch(() => {
          this.closePup()
        });
    },
    approvalOk () {
      this.$refs["formApproval"].validate(valid => {
        if (valid) {
          this.approvalSave();
        }
        return false;
      });
    },

    approvalSave () {
      if (this.flows.length === 0) return this.$message.error("请添加审批人");
      let nodes = [];
      const { approvalName, approvalType,useFileAuditFlag, dingTalkUserIds } = this.approvalModel,
        dingtokenInfo = JSON.parse(sessionStorage.getItem("dingloginInfo"));
      // console.log('dingTalkUserIds', dingTalkUserIds);
      const users = dingTalkUserIds && dingTalkUserIds.map(user => {
        return {
          dingTalkUserName: user.dingTalkUserName ? user.dingTalkUserName : user.name,
          dingTalkUserId: user.dingTalkUserId ? user.dingTalkUserId : user.emplId
        }
      })
      const workflowReq = {
        flowName: approvalName,
        flowType: approvalType,
        useFileAuditFlag:useFileAuditFlag,
        ccUsers: [],
        corpId: dingtokenInfo.dingTalkCorpId,
        dingTalkUserId: dingtokenInfo.dingTalkUserId,
        // dingTalkUsers: users
      };
      if (!this.flowType && dingTalkUserIds.length === 0) return this.$message.error('请选择使用范围')
      if (this.flowId) {
        workflowReq.flowId = this.flowId;
      }
      // approvalModel.approvalType 1 顺序审 2 会审
      if (approvalType === 1) {
        // 顺序审
        this.flows.forEach(user => {
          nodes.push({
            userApproveUsers: [{ name: user.name, userId: user.emplId }]
          });
        });
      }
      if (approvalType === 2) {
        // 会审
        const userList = [];
        this.flows.forEach(user => {
          userList.push({
            name: user.name,
            userId: user.emplId
          });
        });
        nodes.push({ userApproveUsers: userList });
      }
      workflowReq.nodes = nodes;
      workflowReq.useScopeType = 1 // 0:合同，1:印章
      dingtalkApi.makeFlow(workflowReq).then(res => {
        if (!res.success) return this.$message.error(res.description);
        // this.$router.push({ path: "/console/dingComponents/dingFlow" });
        // this.$router.go(-1)
        callbackLog({
          module:6,
          desc:`${workflowReq.flowId ? '编辑' : '新增'}${workflowReq.useScopeType == 1 ? '印章' :'合同'}审批流程：${approvalName}(ID：${workflowReq.flowId || res.data})`
          })
        this.$message.success(res.description || '操作成功')
        this.closePup()
        this.$emit('filterSearch')
      });
    },
    closePup () {
      this.$emit('update:addFlowPupVisi', false)
    },
    // 添加审批人
    handleClickFlowPlus () {
      // 鉴权 + 选人
      const corpId = sessionStorage.getItem("corpId"), _this = this;
      let users = [], assets = [];
      _this.flows.forEach(item => {
        item.emplId !== '-1' ? users.push(item.emplId) : assets.push(item);
      });
      dd.chooseStaffForPC({
        max: 50,
        users,
        corpId,
        multiple: true,
        success: res => {
          _this.flows = [...assets, ...res];
        },
      }).catch((err) => { console.log('catch_err', err); });
    },
    addManager () {
      const have = this.flows.some(item => item.emplId === '-1')
      if (have) return this.$message.error('请勿重复添加审批人')
      this.flows.push({ name: '部门直属主管', emplId: '-1' })
    },
  },
  mounted () {
    // if (this.$route.query.flowId) {
    //   this.initApprovalInfo();
    // }
  },
  watch: {
    addFlowPupVisi: {
      handler (newVal) {
        if (newVal && this.flowId) {
          this.initApprovalInfo();
          this.intUpdate();
        }
      },
      immediate: true
    },
  },
};
</script>

<style scoped lang="less">
.close-icon {
  width: 30px;
  height: 30px;
  position: absolute;
  top: 5px;
  right: 10px;
}
.close_icon {
  cursor: pointer;
  background-image: url("/images/icon/icon_close.png");
  background-size: 100% 100%;
  &:hover {
    background-image: url("/images/icon/icon_colse_hover.png");
  }
}
.flow-sty {
  display: flex;
  flex-wrap: wrap;
  .box-sty {
    display: flex;
    align-items: center;
  }
}
.men-item {
  margin: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
}
.item-close {
  display: inline-block;
  width: 20px;
  height: 20px;
  position: absolute;
  top: 0;
  right: 0;
}
</style>
<style scoped>
.approval {
  padding: 20px;
  position: relative;
  background: #ffffff;
}

.footer {
  border-top: 1px solid #cccccc;
  padding: 15px;
}

.custom-a {
  color: #5597ec;
  text-decoration: underline;
}

.custom-a:hover {
  color: red;
}

.content >>> .el-form-item {
  margin-bottom: 40px;
}
</style>



// WEBPACK FOOTER //
// pages/console/dingComponents/dingSignApproval.vue